import Vue from 'vue'
import Vuex from 'vuex'
import base from "./modules/base";
import link from "@/store/modules/link";


Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    base,
    link
  }
})
